import React from 'react';
interface TrustLineProps {
  items: string[];
}
export function TrustLine({
  items
}: TrustLineProps) {
  return <p className="mt-2.5 text-center font-display text-[11.5px] font-medium uppercase tracking-wide text-steel sm:text-[13px]" data-id="element-194" data-mp="3oxdpw95eg11l">
      {items.map((item, i) => <React.Fragment key={item} data-id="element-195" data-mp="3fxqrlw7yvbcr" data-mpi={i}>
          {i > 0 && <span className="mx-1.5 text-line" data-id="element-196" data-mp="3fz218co3fdbs">|</span>}
          {item}
        </React.Fragment>)}
    </p>;
}